import React, { Component, useState } from "react";
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import SvgIcon from '@material-ui/core/SvgIcon';
import Icon from '@material-ui/core/Icon';
import cyan from '@material-ui/core/colors/cyan';
import { createMuiTheme, withStyles, makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import Select from '@material-ui/core/Select';
import { Link } from 'react-router-dom';

const ColorButton = withStyles(theme => ({
  root: {
    backgroundColor: cyan[500],
    '&:hover': {
      backgroundColor: cyan[700],
    },
	width: "100%",
	fontWeight: "bold",
	fontSize: "12px",
	lineHeight: "12px",
	height: "24px"
  },
}))(Fab);

class Logout extends Component {

	constructor (props) {
		super(props);
		this.state = {
			switch_username: '',
			dialogOpen: false
		};
		this.handleClick=this.handleClick.bind(this);
		this.switchUser = this.switchUser.bind(this);
		this.switchLogout = this.switchLogout.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleClickOpen = this.handleClickOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChangeUser = this.handleChangeUser.bind(this);
		this.orderUsers=this.orderUsers.bind(this);
//		console.log("history: "+this.props.history);
	}
	handleClickOpen() {
		this.setState({dialogOpen: true});
	};
	
	handleClose(){
		this.setState({dialogOpen: false});
	};
  
	handleClick() {
		this.props.logout();
	}

	switchUser() {
		this.props.switchUser(this.state.switch_username);
		this.setState({dialogOpen: false});
		this.setState({changed: true});
	}
	
	switchLogout() {
		this.props.switchLogout();
	}
	
	handleChange(e) {
		e.preventDefault();
		const {name, value} = e.target;
		this.setState({[name]: value});
	}
	
	handleChangeUser(e, v) {
//	handleChangeUser(e) {
		e.preventDefault();
		//this.setState({switch_username: v.username});
		this.setState({switch_username: v});
	}
	
	orderUsers(a, b){
		return a.username.localeCompare(b.username);
	}
	
	render(){
		//console.log(this.props.user);
		var switchuser='';
		var originaluser='';
		var originaluserdesc = '';
		var dialog='';
		if(this.props.user.switch_user==''){
			let users = [];
			if(this.props.user.role==='ADMIN'){
				//Object.values(this.props.userRecords).sort(this.orderUsers).forEach(element => users.push(<option value={element.username}>{element.username}</option>))
				Object.values(this.props.userRecords).forEach(element => users.push(element.username))
			}else if(typeof this.props.user.switchUser !== 'undefined' && this.props.user.switchUser.length>1){
				//this.props.user.switchUser.split(",").forEach(element => users.push(<option value={element}>{element}</option>));
				users = this.props.user.switchUser.split(",");
			}
			switchuser=<Autocomplete
					id="switch_username"
					name="switch_username"
					options={users}
					getOptionLabel={(option) => option}
					//options={Object.values(this.props.userRecords).sort(this.orderUsers)}
					//getOptionLabel={(option) => option.username}
					style={{ width: 300 }}

					onChange={this.handleChangeUser}
					renderInput={(params) => <TextField {...params} label="Users..." variant="outlined" />}
				/>
			originaluser=<div className="col-2"></div>
		}else{
			switchuser=<div className="col-4"><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: "#F00", cursor: "pointer", paddingLeft: "30px"}} onClick={this.switchLogout}>&#59393;</Icon>[{this.props.user.switch_user}]</div>
			originaluser=<div className="col-2"><Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: "#F00", cursor: "pointer"}} onClick={this.switchLogout}>&#59393;</Icon></div>
			originaluserdesc = <span>[{this.props.user.switch_user}]</span>;
		}
		if(this.props.user.role==='ADMIN' || (typeof this.props.user.switchUser !== 'undefined' && this.props.user.switchUser.length>1)){
			dialog=<Dialog open={this.state.dialogOpen} onClose={this.handleClose} aria-labelledby="change-user-dialog">
					<DialogTitle id="change-user-dialog">Change user</DialogTitle>
					<DialogContent>
						{switchuser}
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose} color="primary">
						Cancel
						</Button>
						<Button onClick={this.switchUser} color="primary">
						OK
						</Button>
					</DialogActions>
				</Dialog>
		}
		//style={{ height:"100%", marginBottom:"15px"}}
		return (
			<div style={{width:"100%"}}>
				{dialog}
				<div className="row align-items-center g-0">
					<div className="col-2">
						<Link to={`/userForm/${this.props.user.id}/0`}>
							<Icon className="hoverlight" style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#fff", cursor: "pointer"}}>&#59392;</Icon>
						</Link>
					</div>
					<div className="col-9">
						<div className="row align-items-center">
							<div className="col-2">
								<Icon className="hoverlight" justify="flex-start" onClick={this.handleClickOpen} style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#fff", cursor: "pointer"}}>&#62144;</Icon>
							</div>
							<div className="col-8">
								{this.props.user.username} {originaluserdesc}
							</div>
							{originaluser}
						</div>
					</div>
					<div className="col-1">
						<Icon className="hoverlight" onClick={() => { this.handleClick(); }} style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#fff", cursor: "pointer", textAlign: "right"}}>&#59394;</Icon>
					</div>
				</div>
			</div>
		);
	}
}

export default Logout;